import {
	PaletteColor,
	PaletteColorOptions,
	createTheme,
} from "@mui/material/styles";
import { colors } from "./colorsPalette";

declare module "@mui/material/styles" {
	interface BreakpointOverrides {
		mobile: true;
		xs: true;
		sm: true;
		md: true;
		lg: true;
		xl: true;
		xxl: true;
	}
	interface Palette {
		disabled?: PaletteColor;
	}

	interface PaletteOptions {
		disabled?: PaletteColorOptions;
	}
}

export const theme = createTheme({
	palette: {
		primary: {
			main: colors.brown.primary,
			//this one is for the typographies, for example in the details
			dark: colors.brown.primary,
			light: colors.brown.light,
		},
		secondary: {
			main: colors.gray.light,
			light: colors.white.dark,
			dark: colors.white.darker,
		},
		background: {
			default: colors.white.background,
			paper: colors.white.paper,
		},
		info: {
			main: colors.black.info,
			dark: colors.gray.info_darker,
			light: colors.gray.info_dark,
		},
		disabled: {
			main: colors.gray.normal_disabled,
			light: colors.gray.lighter,
		},
		success: {
			main: colors.green.success,
		},
		error: {
			main: colors.red.error,
		},
		warning: {
			main: colors.orange.warning,
		},
	},
	typography: {
		fontFamily: "Inter, sans-serif",
		fontSize: 16,
		h1: {
			fontFamily: "Inter, sans-serif",
			fontSize: 32,
			fontWeight: "800",
			color: colors.black.info,
		},
		h2: {
			fontFamily: "Inter, sans-serif",
			fontSize: 34,
			fontWeight: "600",
			color: colors.black.info,
		},
		h3: {
			fontFamily: "Inter, sans-serif",
			fontSize: 22,
			fontWeight: "600",
			color: colors.black.info,
		},
		h6: {
			fontFamily: "Inter, sans-serif",
			fontWeight: "500",
			fontSize: 16,
		},
	},
	components: {
		MuiTypography: {
			styleOverrides: {
				root: {
					fontSize: "16px",
				},
			},
		},
		MuiButton: {
			defaultProps: {
				disableRipple: true,
			},
			styleOverrides: {
				root: {
					fontSize: 16,
					fontFamily: "Noto Sans Gujarati",
					fontWeight: 700,
					textTransform: "initial",
					color: colors.gray.info_dark,
					borderWidth: "2px",
					borderRadius: "10px",
					"&.Mui-disabled": {
						backgroundColor: colors.gray.normal_disabled,
						color: "#CDC5BE",
						borderWidth: "2px",
					},
				},
				contained: {
					color: colors.white.paper,
					"&.Mui-disabled": {
						backgroundColor: colors.gray.normal_disabled,
						color: "#CDC5BE",
						borderWidth: "2px",
					},
				},
				outlined: {
					"&:hover": {
						borderWidth: "2px",
					},
				},
				text: {
					color: colors.brown.primary,
					textDecoration: "underline",
					"&:hover": {
						backgroundColor: "transparent",
					},
					"&.Mui-disabled": {
						backgroundColor: "transparent",
						color: "#CDC5BE",
					},
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					backgroundColor: "transparent",
					"& fieldset": {
						border: `2px solid ${colors.brown.primary}`,
						borderRadius: "10px",
					},
					"& input": {
						color: colors.black.info,
						backgroundColor: "transparent",
						fontWeight: 400,
						fontSize: "16px",
						height: "50px",
						padding: "0px 14px",
					},
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				icon: {
					color: colors.gray.info_dark,
					fontSize: "large",
				},
				outlined: {
					fontSize: "16px",
					fontWeight: 500,
					color: colors.gray.info_dark,
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				arrow: {
					color: colors.orange.warning,
				},
				tooltip: {
					backgroundColor: colors.orange.warning,
				},
			},
		},
	},
	breakpoints: {
		values: {
			mobile: 0,
			xs: 550,
			sm: 750,
			md: 900,
			lg: 1000,
			xl: 1200,
			xxl: 1536,
		},
	},
});
